import { AUDIT_STATUS_OPTIONS } from '~services/constant/audit';
import HelperOptions from '~component/helper/helper-options';

// 是或否
export default {
  functional: true,
  render(createElement, context) {
    const { data } = context;

    return (
      <HelperOptions
        { ...data }
        options={ AUDIT_STATUS_OPTIONS }
      />
    );
  },
};
